export const devInfoDetails = {
  name: "Roman Khatri",
  address: "Lalitpur, Nepal",
  email: "romanforgit@gmail.com",
};

export const introdata = {
  title: "Full-stack developer building clear product experiences",
  animated: {
    first: "Next.js and TypeScript developer",
    second: "React Native builder for web and mobile",
    third: "Focused on travel, booking, and business products",
  },
};

export const aboutMe = {
  intro:
    "My name is Roman Khatri. I come from the eastern part of Nepal, Birtamode-4, Jhapa. I am a student, currently doing my bachelors in Computer Science and Information Tech.",
  earlier: {
    first:
      " I went to Newton's Education Academy for Middle school and Kanchanjunga Namuna College was my High school.",
    second:
      "I consider myself as a well-disciplined and a bright student during my childhood. Even though my life turned dramatically into Techs, however I was once a student of Biological Science and wanted to persue more knowledge on Medical Science. Thus I did my pre-medics from Vibrant Institue in Kathmandu and started the preparation.",
    third:
      " Along with uncertain exam dates and covid pendamics, my preparation was getting disturbed at the last hours, which probably led me to not get a scholarship in Dental Surgery, neither MBBS.",
  },
  present: {
    first:
      "I then had to grab an academic seat on Mechi Multiple Campus for BSC. CSIT as a tech student. I am now dedicated to being a professional in Software Engineering, and my prime interests are web development and AI. I have worked many hours on projects that I believe will support me in this journey. In college, we have been taught about many high-level and low-level languages. Besides academic studies, I am a passionate musician and have been doing professional music for 4 years now. I have a good number of followers on social media, especially on TikTok. I am trying to balance both music and tech in my life and am currently focused on doing what makes human life easier.",
  },
};

export const socialMedia = {
  facebook: "https://www.facebook.com/RomanGhimire7902/",
  instagram: "https://www.instagram.com/gromanate",
  github: "https://www.github.com/git4roman",
  tiktok: "https://www.tiktok.com/@gromanate",
  linkedin: "https://www.linkedin.com/in/romankhatri8/",
};
